import { SpecialHolidayType } from 'types/calendar'
import { dateToString } from 'lib/helper'
export type DayOfWeekType = 'sun' | 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'hol'

export class DaysOfWeek {
  readonly daysOfWeek: DayOfWeekType[]
  readonly daysOfWeekValue: { [key: string]: { name: string; shortName: string; order: number } }

  constructor() {
    this.daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'hol']
    this.daysOfWeekValue = {
      mon: {
        name: '月曜日',
        shortName: '月',
        order: 1,
      },
      tue: {
        name: '火曜日',
        shortName: '火',
        order: 2,
      },
      wed: {
        name: '水曜日',
        shortName: '水',
        order: 3,
      },
      thu: {
        name: '木曜日',
        shortName: '木',
        order: 4,
      },
      fri: {
        name: '金曜日',
        shortName: '金',
        order: 5,
      },
      sat: {
        name: '土曜日',
        shortName: '土',
        order: 6,
      },
      sun: {
        name: '日曜日',
        shortName: '日',
        order: 7,
      },
      hol: {
        name: '祝日',
        shortName: '祝',
        order: 8,
      },
    }
  }

  getDaysOfWeek(): DayOfWeekType[] {
    return this.daysOfWeek
  }
  getSharedWeekdays(): DayOfWeekType[] {
    return ['wed', 'thu', 'fri']
  }
  getSharedWeekends(): DayOfWeekType[] {
    return ['sat', 'sun']
  }
  getShortName(dayOfWeek: DayOfWeekType): string {
    return this.daysOfWeekValue[dayOfWeek].shortName
  }
  getName(dayOfWeek: DayOfWeekType): string {
    return this.daysOfWeekValue[dayOfWeek].name
  }
  // 渡された日付の曜日を取得する（祝日かどうかも判定）
  getDayOfWeek(date: Date, specialHolidays: SpecialHolidayType[]): DayOfWeekType {
    const isHoliday = specialHolidays.some((specialHoliday) => {
      return specialHoliday.date === dateToString(date) && specialHoliday.is_holiday
    })

    if (isHoliday) {
      return 'hol'
    } else {
      const day = date.getDay()
      return this.daysOfWeek[day]
    }
  }
  /* 日曜始まりではなく月曜始まりのorderを実装しているので、JavaScriptのDate型のgetDay()と併用はできない */
  getOrder(dayOfWeek: DayOfWeekType): number {
    return this.daysOfWeekValue[dayOfWeek].order
  }
  getEarlyOrder(daysOfWeek: DayOfWeekType[]): number {
    let earlyOrder = 8 // 最終順序(祝日)
    daysOfWeek.map((dayOfWeek) => {
      const order = this.getOrder(dayOfWeek)
      if (earlyOrder > order) earlyOrder = order
    })
    return earlyOrder
  }
  isDayOfWeekType(value: string): boolean {
    return (
      value === 'sun' ||
      value === 'mon' ||
      value === 'tue' ||
      value === 'wed' ||
      value === 'thu' ||
      value === 'fri' ||
      value === 'sat' ||
      value === 'hol'
    )
  }
}
